import {ButtonStyle} from 'ui-library/buttons/Button';
import * as modals from 'util/Modals';

export default async function runConfirmDeleteModal(props: {
  typeName: string;
  /**
   * Modal title
   *
   * @default `Delete ${typeName}`
   */
  title?: string;
  /**
   * Modal message
   *
   * @default `Are you sure you want to delete the ${typeName}? It cannot be recovered.`
   */
  message?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
  onExit?: () => void;
}): Promise<boolean> {
  const {typeName, title, message, onSubmit, onCancel, onExit} = props;
  return (await Promise.resolve(
    modals.confirm(
      title ?? `Delete ${typeName}`,
      message ?? `Are you sure you want to delete the ${typeName}? It cannot be recovered.`,
      ButtonStyle.NEGATIVE,
      {
        acceptText: 'Delete',
        rejectText: 'Cancel',
        enableRedesign: true,
        promiseCompatible: true,
        onSubmit,
        onCancel,
        onExit,
      }
    )
  )) as boolean;
}
